module.exports = __webpack_public_path__ + "static/media/ryan_crowley_serious.58ad6b17.png";